import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Clock, CheckCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function Pending() {
  const { application, profile, signOut } = useAuth();
  const navigate = useNavigate();

  // If user has active profile, redirect
  if (profile?.membership_status === 'active') {
    navigate('/');
    return null;
  }

  // If application is approved, show approved message
  if (application?.status === 'approved') {
    return (
      <div className="min-h-screen flex items-center justify-center px-4 py-12">
        <div className="max-w-md w-full text-center">
          <div className="w-24 h-24 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle size={48} className="text-green-400" />
          </div>
          <h1 className="text-3xl font-bold text-brand-gold mb-4">Application Approved!</h1>
          <p className="text-gray-400 mb-8">
            Congratulations! Your application has been approved. You now have access to all member features.
          </p>
          <button
            onClick={() => navigate('/')}
            className="w-full py-4 bg-brand-gold text-brand-dark font-bold rounded-xl hover:bg-yellow-400 transition-colors"
            data-testid="continue-btn"
          >
            Continue to Events
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12">
      <div className="max-w-md w-full text-center">
        <div className="w-24 h-24 bg-brand-gold-light rounded-full flex items-center justify-center mx-auto mb-6">
          <Clock size={48} className="text-brand-gold" />
        </div>
        <h1 className="text-3xl font-bold text-brand-gold mb-4">Application Under Review</h1>
        <p className="text-gray-400 mb-8">
          Thank you for applying to the Economic Club of San Antonio! Our team is currently reviewing your application. 
          You will receive an email notification once a decision has been made.
        </p>
        <div className="bg-white/5 border border-brand-gold-border rounded-2xl p-6 mb-6">
          <h2 className="text-lg font-bold text-white mb-4">What's Next?</h2>
          <ul className="text-left text-gray-400 space-y-3 text-sm">
            <li>• Our membership committee will review your application</li>
            <li>• You may be contacted for additional information</li>
            <li>• Approved members may refer other prospective members</li>
            <li>• Once approved, you'll have full access</li>
          </ul>
        </div>
        <button
          onClick={() => navigate('/')}
          className="w-full py-4 border-2 border-brand-gold text-brand-gold font-bold rounded-xl hover:bg-brand-gold-light transition-colors mb-3"
          data-testid="preview-events-btn"
        >
          Preview Events
        </button>
        <button
          onClick={signOut}
          className="w-full py-4 text-gray-400 hover:text-white transition-colors text-sm"
          data-testid="signout-btn"
        >
          Sign Out
        </button>
      </div>
    </div>
  );
}
